import { fetchPostAppSettings} from '../apiRequests/api';
import {useAuth0} from "@auth0/auth0-react";
import { React, useEffect, useState } from 'react';
import { useAppSettings } from '../hooks/useAppSettings';
import Loading from './Loading';
import "../sass/components/admin.scss"
import { useHistory, Link } from "react-router-dom";
import AdminMetrics from './AdminMetrics';
import { myProductsLabel } from '../settings';

const MAX_BANNER_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB

export default function AdminSettings(props) {
  const settings = useAppSettings();
  const [formData, setFormData] = useState(settings);
  const {getIdTokenClaims} = useAuth0();
  let history = useHistory();

  async function handleSubmit(event) {
    event.preventDefault();
    const token = await getIdTokenClaims();
    const data = await fetchPostAppSettings(formData, token.__raw);
    alert('App settings saved!');
    window.location.reload();
  }

  function handleChange (event) {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  }

  function handleImageChange(event) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file.');
      event.target.value = '';
      return;
    }
    if (file.size > MAX_BANNER_IMAGE_SIZE) {
      alert('Image is too large. Please select a file under 2MB.');
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setFormData((prevFormData) => ({ ...prevFormData, banner_image: reader.result }));
    };
    reader.readAsDataURL(file);
  }

  function handleRemoveImage() {
    setFormData((prevFormData) => ({ ...prevFormData, banner_image: '' }));
  }

  useEffect(() => {
    if (!settings['__empty'] && !settings['__is_admin_user']) {
      history.push("/product-list");
    } else {
      setFormData(settings)
    }
  }, [settings])
  return (
    <div>
      {settings['__empty'] ?
        <div className='product-list-wrapper'>
          {/*Imitate frontpage */}
          <h1 className='page-title'>{myProductsLabel}</h1>
          <Loading isLoading={true}/>
        </div>
        :
        <div className="page orders-page admin">
          <h2 className='page-title v2'>Trade App Settings</h2>
          <div className='admin__note'>
            Customise your Trade App using the options below. New to these
            settings? Read the{' '}
            <Link to='/admin/guide'>
              Admin Guide
            </Link>{' '}
            for a full walkthrough of every feature.
          </div>
          <form className='admin__form' onSubmit={handleSubmit}>

            <fieldset className='admin__form-field section'>
              <h3 className='admin__form-label'>Banner</h3>
              <p>Display a banner above the title on all pages, using either
                HTML code or an uploaded image. If both are filled in, the
                HTML code is shown and the image is ignored.</p>

              <div className='admin__banner-option'>
                <h4 className='admin__form-sublabel'>Option 1: HTML code</h4>
                <p className='admin__form-hint'>For Elfsight banners, paste
                  only the HTML content part of the widget, ignoring the code
                  within the "script" tags.</p>
                <textarea className='admin__form-textarea'
                          value={formData['banner']} id="banner" name="banner"
                          onChange={handleChange}/>
              </div>

              <div className='admin__form-divider'>Or</div>

              <div className='admin__banner-option'>
                <h4 className='admin__form-sublabel'>Option 2: Image</h4>
                <p className='admin__form-hint'>Accepted formats: JPG, PNG,
                  GIF or WEBP. Max file size: 2MB. For best results, use a
                  wide, short image (for example 1200x200px).</p>

                {formData['banner_image'] &&
                  <div className='admin__banner-image-preview'>
                    <img src={formData['banner_image']} alt="Banner preview"/>
                    <button type="button" className='btn btn--secondary'
                            onClick={handleRemoveImage}>Remove image</button>
                  </div>
                }
                <input className='admin__form-file' type="file"
                       accept="image/*" id="banner_image" name="banner_image"
                       onChange={handleImageChange}/>
              </div>

              <input className='admin__form-submit btn btn--primary'
                     type="submit" value="Update Banner"/>
            </fieldset>

          </form>

          <AdminMetrics/>
        </div>
      }
    </div>
  );
}